import validator from "validator";

validator.isEven = function(number) {
  return number % 2 == 0;
};



/** WEBPACK FOOTER **
 ** ./js/helpers/validator-extends.js
 **/